import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CajaRutaDTOList, ListFiltroCargasDescargas } from "../list";
import { ReporteCargaAdministradoresEdit, ReporteCargaAdministradores } from "./reporteCargaAdministrador";

const CargaAdministradoresButton = kea.defaultProps(kea.Button, { children: "Imprimir reporte carga adminsitradores", iconClass: fa("print"), style: "warning" });

interface Props {
    permisos: models.Rol;
}

class PantallaCargaDescargaNoRX extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    verGenerarReporte = (x: Props) => x.permisos.Reportes.VerReporteCargaAdministradores;

    onRegresar = () => {
        history.go("../");
    }

    onGenerarReporteCargaAdministradores = async () => {
        const value: ReporteCargaAdministradores = {} as ReporteCargaAdministradores;
        const result = await this.modals.showModal(ReporteCargaAdministradoresEdit, undefined, value);
        if (result.result) {
            const params = result.value;
            const data = await resources.CargaDescarga.ReporteCargaAdministradores(params.idCamion, params.idSegmento);
            kea.printPdf(data);
        }
    }

    render() {
        const verGenerarReporte = this.verGenerarReporte(this.props);
        return (
            <div>
                <kea.Title titulo="Cargas y descargas de caja de ruta" onRegresar={this.onRegresar}>
                    {
                        verGenerarReporte &&
                        <CargaAdministradoresButton onClick={this.onGenerarReporteCargaAdministradores} />
                    }
                </kea.Title>

                <kea.Tab
                    items={[
                        {
                            body: <CajaRutaDTOList />,
                            iconClass: fa("truck"),
                            title: "Cajas de ruta"
                        }, {
                            body: <ListFiltroCargasDescargas/>,
                            iconClass: fa("exchange"),
                            title: "Cargas y descargas"
                        }
                    ]}
                />
                {this.modals.component}
            </div>
        );
    }
}

const PantallaCargaDescargaRx = componentToRx(PantallaCargaDescargaNoRX);

export class PantallaCargaDescarga extends React.PureComponent {

    render() {
        return (
            <PantallaCargaDescargaRx permisos={resources.User.PermisoRx} />
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/pantalla/index.tsx